const COLORS = {
  POPPY: "#BB1B01",
  OAT: "#FBF7EC",
  BLACK: "#0b0f0e",
  WHITE: "#FFFFFF",
};

export default COLORS;
